import { Box, Button, Input, Text, useToast } from '@chakra-ui/react'
import { useState } from 'react'
import { BASE_URL } from '../Constants/urls'

export function UploadTranslations() {
  const [file, setFile] = useState<File>()
  const [name, setName] = useState<string>()
  const toast = useToast()

  return (
    <Box textAlign='center'>
      <Text fontWeight={'bold'}>Upload Translation file for Samay</Text>

      <Box position='relative' w='xl' margin='auto' mt={4} cursor='pointer'>
        <Box
          w={'xl'}
          h={'sm'}
          margin='auto'
          display={'flex'}
          justifyContent='center'
          alignItems='center'
          borderWidth={1}
          borderStyle='dashed'
          borderColor='black'
          rounded={'2xl'}
        >
          {name || 'No file selected'}
        </Box>
        <Input
          position='absolute'
          type='file'
          w={'xl'}
          h={'sm'}
          mt={3}
          left={0}
          top={0}
          opacity={0}
          borderWidth={1}
          borderColor='black'
          onChange={(e) => {
            const files = e.target.files
            if (files && files.length > 0) {
              const translationFile = files[0]
              if (translationFile.type !== 'text/csv') {
                toast({
                  title: 'Invalid file type',
                  description: 'Upload a csv file',
                  position: 'top',
                  status: 'error',
                })
                return
              } else {
                setFile(translationFile)
                setName(translationFile.name)
              }
            }
          }}
        />
      </Box>

      <Button
        mt={4}
        variant={'solid'}
        bg={'#708A82'}
        color='white'
        fontWeight={'normal'}
        onClick={async () => {
          if (!file) {
            toast({
              title: 'File not found',
              description: 'Please select a file first',
              position: 'top',
              status: 'error',
            })
            return
          }

          var formdata = new FormData()
          formdata.append('translation_file', file, 'translations.csv')

          var requestOptions: RequestInit = {
            method: 'POST',
            body: formdata,
            redirect: 'follow',
          }

          const res = await fetch(
            `${BASE_URL}/translations/update_translations`,
            requestOptions,
          )

          if (res.ok) {
            const body = await res.json()
            if (!body.error) {
              toast({
                title: 'Uploaded Successfully',
                description:
                  'Translations file has been uploaded successfully, changes will reflect soon.',
                status: 'success',
                position: 'top',
              })
              setFile(undefined)
              setName(undefined)
            }
          }
        }}
      >
        Upload File
      </Button>
    </Box>
  )
}
